import React from 'react';
import PropTypes from 'prop-types';
import ModalBody from 'Modals/components/ModalBody';
import LoadingBar from 'Modals/components/LoadingBarModalBody/components/LoadingBar';

export default class LoadingBarModalBody extends React.Component {
  constructor(props) {
    super(props);
    this.animateLoadingBar = this.animateLoadingBar.bind(this);
    this.renderDynamicContent = this.renderDynamicContent.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.state = {
      percentComplete: this.props.percentComplete,
      stepCount: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.finalStep && nextProps.finalStep) {
      clearInterval(this.animationInterval);
      this.setState({
        percentComplete: nextProps.finalStep.percent,
        stepCount: 0,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isAnimating && !prevProps.isAnimating) {
      this.animateLoadingBar();
    }
  }

  animateLoadingBar() {
    let i = 0;
    this.animationInterval = setInterval(() => {
      this.setState({
        percentComplete: this.props.loadSteps[i].percent,
        stepCount: i,
      });

      i += 1;
      if (i === this.props.loadSteps.length) {
        clearInterval(this.animationInterval);
      }
    }, this.props.loadSteps[i].interval);
  }

  renderContent(step) {
    const currentContentData = step.content;
    if (Object.keys(this.props.additionalData).length > 0) {
      currentContentData.additionalData = this.props.additionalData;
    }

    return React.Children.map(this.props.children, child => (
      React.cloneElement(child, { ...currentContentData })
    ));
  }

  renderDynamicContent() {
    if (this.props.finalStep) {
      return this.renderContent(this.props.finalStep);
    }

    return this.renderContent(this.props.loadSteps[this.state.stepCount]);
  }

  render() {
    const modalContent = this.props.isDynamicContent ?
                         this.renderDynamicContent() :
                         this.props.children;

    return (
      <ModalBody modalBodyClass={this.props.loadingModalBodyClasses}>
        { modalContent }
        <LoadingBar
          percentComplete={this.state.percentComplete}
          loadingClasses={this.props.loadingBarClasses}
        />
      </ModalBody>
    );
  }
}

LoadingBarModalBody.propTypes = {
  // provides the loading bar with the `percent` of progress and the `interval`
  // in MS to wait for at each step
  loadSteps: PropTypes.arrayOf(PropTypes.shape({
    percent: PropTypes.number.isRequired,
    interval: PropTypes.number.isRequired,
  })).isRequired,
  finalStep: PropTypes.shape({
    percent: PropTypes.number,
    interval: PropTypes.number,
    content: PropTypes.shape({
      renderingFontsPercent: PropTypes.number,
      loadingPagesPercent: PropTypes.number,
      initializingEditorPercent: PropTypes.number,
      finalizingPercent: PropTypes.number,
    }),
  }),
  additionalData: PropTypes.shape({
    format: PropTypes.string,
  }),
  isAnimating: PropTypes.bool,
  percentComplete: PropTypes.number,
  isDynamicContent: PropTypes.bool,
  // provides the key, value pairs of each object as the props for the children
  // at that load step
  children: PropTypes.node.isRequired,
  loadingBarClasses: PropTypes.string,
  loadingModalBodyClasses: PropTypes.string,
};

LoadingBarModalBody.defaultProps = {
  finalStep: null,
  additionalData: {
    format: null,
  },
  isAnimating: false,
  percentComplete: 0,
  isDynamicContent: false,
  loadingBarClasses: 'progress-striped active',
  loadingModalBodyClasses: 'modal-body',
};



// WEBPACK FOOTER //
// ./src-react/Modals/components/LoadingBarModalBody/index.jsx